import { useTranslations } from 'next-intl';
import { LIST_TYPES_DISPLAY } from '../../types';
import { ListType } from 'services/savedLists/types';

export interface SavedListTableTypeCellProps {
  type: ListType;
}

const SavedListTableTypeCell = ({ type }: SavedListTableTypeCellProps) => {
  const t = useTranslations();

  return (
    <div className="d-flex align-items-center">
      {LIST_TYPES_DISPLAY[type].icon}
      <span className="text-capitalize ms-2 d-none d-md-flex">
        {t(LIST_TYPES_DISPLAY[type].key)}
      </span>
      <span className="text-capitalize ms-1 cat-u-theme-typography-footnote d-flex d-md-none">
        {t(LIST_TYPES_DISPLAY[type].key)}
      </span>
    </div>
  );
};

export default SavedListTableTypeCell;
